import getConfig from 'next/config';

import { PageNumberProductPickupExpiration, ProductPickupExpiration } from '../../types/typefetch';

export default async function getProductsForPickup(
  page: number = 0,
  live: boolean = false,
): Promise<PageNumberProductPickupExpiration | undefined> {
  const { publicRuntimeConfig } = getConfig();
  const response = await fetch<'api'>(
    `${publicRuntimeConfig.bcom.baseUrl}/api/v1/member/me/products/pickup/?page=${page}&live=${live}`,
    {
      method: 'GET',
    },
  );

  if (!response.ok) {
    return undefined;
  }

  return await response.json();
}

export async function getProductForPickup(
  articleNumber: number,
): Promise<ProductPickupExpiration | undefined> {
  const { publicRuntimeConfig } = getConfig();
  const response = await fetch<'api'>(
    `${publicRuntimeConfig.bcom.baseUrl}/api/v1/member/me/products/pickup/${articleNumber}/`,
  );

  if (!response.ok) {
    return undefined;
  }

  return await response.json();
}
